import { ContactSupport, HistoryEdu, SupportAgent, SystemUpdateAlt } from '@mui/icons-material';

const sidebarConfig = [
  {
    title: 'Downloads',
    path: '/downloads',
    icon: <SystemUpdateAlt
      sx={{
        height: 22, width: 22
      }}
    />
  },
  // {
  //   title: 'Knowledgebase',
  //   path: '/knowledgebase',
  //   icon: <HistoryEdu
  //     sx={{
  //       height: 22, width: 22
  //     }}
  //   />
  // },
  // {
  //   title: 'Tickets',
  //   path: '/tickets',
  //   icon: <ContactSupport
  //     sx={{
  //       height: 22, width: 22
  //     }}
  //   />
  // },
  {
    title: 'Contact Us',
    path: 'https://avidid.com/message',
    newTab: true,
    icon: <SupportAgent
      sx={{
        height: 22, width: 22
      }}
    />
  }
];

export default sidebarConfig;
